import { Stack, Typography } from '@mui/material';
import { CustomDialog } from 'components/modules';
import { FallbackLogoIcon } from '../Fallback/styles';

export const ModalLoading = ({ text }: { text?: string }) => (
  <CustomDialog>
    <Stack sx={{ overflow: 'hidden', alignItems: 'center' }}>
      <FallbackLogoIcon $width="124px" $height="122px" $margin="20px 0" />
      {text && <Typography sx={{ fontSize: 20 }}>{text}</Typography>}
    </Stack>
  </CustomDialog>
);
